export default __webpack_public_path__ + "static/media/Consceientia.9066ba4c.png";